import initialState from './initialState';
import { types } from '../actions/boardActions';
import { DateTime } from 'luxon';
import { Reactions } from '../models/survey/Reactions';

export default function boardThreadDetailsReducer(state = initialState.boardThreadDetails, action) {
  switch (action.type) {
    case types.GET_POSTS: {
      return { fetching: true };
    }
    case types.GET_POSTS_SUCCESS: {
      const { data } = action;
      return { fetching: false, data };
    }
    case types.GET_POSTS_FAILURE: {
      return { fetching: false, data: null };
    }
    case types.GET_NEXT_POSTS_SUCCESS: {
      const { data } = action;
      data.posts = [...state.data.posts, ...data.posts];
      return { fetchingNext: true, data: data };
    }
    case types.ADD_POST_SUCCESS: {
      const { user } = action;
      const { id, content, files, images } = action.data;
      const updatedThread = Object.assign({}, state.data);
      let reactions = {};
      
      Object.keys(Reactions).forEach(r => reactions[r] = { count: 0 });

      const post = {
        id,
        content,
        files,
        images,
        reactions,
        createdAt: DateTime.local(),
        createdBy: user ? { firstName: user.firstName, lastName: user.lastName } : null,
      };
      updatedThread.posts = [...updatedThread.posts, post];

      return { fetching: false, data: updatedThread };
    }
    case types.ADD_POST_REACTION_SUCCESS: {
      const { postId, reaction } = action;
      const updatedThread = Object.assign({}, state.data);
      
      const postIndex = updatedThread.posts.findIndex(s => s.id === postId);
      const post = updatedThread.posts[postIndex];
      const reactions = {...post.reactions};
      
      reactions[reaction] = {...reactions[reaction]};
      reactions[reaction].hasReacted = true;
      reactions[reaction].count++;

      updatedThread.posts = [
        ...updatedThread.posts.slice(0, postIndex),
        { ...post, reactions },
        ...updatedThread.posts.slice(postIndex + 1, updatedThread.posts.length)
      ];

      return { fetching: false, data: updatedThread };
    }
    case types.UNDO_POST_REACTION_SUCCESS: {
      const { postId, reaction } = action;
      const updatedThread = Object.assign({}, state.data);
      
      const postIndex = updatedThread.posts.findIndex(s => s.id === postId);
      const post = updatedThread.posts[postIndex];
      const reactions = {...post.reactions};
      
      reactions[reaction] = {...reactions[reaction]};
      reactions[reaction].hasReacted = false;
      reactions[reaction].count--;

      updatedThread.posts = [
        ...updatedThread.posts.slice(0, postIndex),
        { ...post, reactions },
        ...updatedThread.posts.slice(postIndex + 1, updatedThread.posts.length)
      ];

      return { fetching: false, data: updatedThread };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/boardThreadDetailsReducer.js